<button #loginBtn type="button" hidden class="hidden" data-bs-toggle="modal" data-target="#loginPopupModal"></button>

<div #loginPopupModal class="modal fade" id="loginPopupModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content auth-card">

            <button
                class="btn position-absolute border-0 start-0 p-0 top-0 m-3 ms-4 border-0 bg-transparent cursor-pointer"
                *ngIf="showPasswordStep" (click)="goBack()">
                <i class="icon skf-back-arrow"></i>
            </button>

            <button #loginBtnClose type="button" class="btn-close position-absolute border-0 end-0 top-0 m-3 fs-15"
                data-bs-dismiss="modal" aria-label="Close">
            </button>

            <div *ngIf="!showPasswordStep">
                <div class="text-center auth-sub mt-3 fs-30 syne-text">
                    {{ 'login6' | translate }}
                </div>
                <div class="text-center fs-16 pt-2 mb-3">
                    <div> {{ 'checking_existing_account' | translate }}</div>
                    <div>{{ 'create_account_if_needed' | translate }}</div>
                </div>
            </div>

            <div *ngIf="showPasswordStep">
                <div class="d-flex align-items-center mb-0 mt-3">
                    <div class="flex-grow-1 text-center pe-4">
                        <div class="auth-sub fs-30 syne-text">
                            {{ 'sign_in_to_account' | translate }}
                        </div>
                        <div class="fs-16 mt-2 mb-4">
                            {{ 'continue_with_email' | translate:{ email: username.value } }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="auth-left mb-4">
                <form [formGroup]="loginForm">
                    <ng-container *ngIf="!showPasswordStep">

                        <div class="mb-4 mt-3">
                            <div class="position-relative">
                                <input type="email" id="" formControlName="username"
                                    class="form-control rounded-pill syne-text ps-4 pe-5 bdr-black py-2"
                                    placeholder="E-mail">

                                <i
                                    class="icon skf-enevelope position-absolute top-50 end-0 translate-middle-y me-3 text-muted"></i>
                            </div>

                            <div *ngIf="username.touched && username.invalid" class="error-text small mt-1 fs-15 ps-2">

                                <div class="error-text syne-text" *ngIf="username.errors?.['required']">
                                    {{ 'login8' | translate }}
                                </div>

                                <div class="error-text syne-text" *ngIf="username.errors?.['pattern']">
                                    {{ 'invalid_email' | translate }}
                                </div>

                            </div>
                        </div>

                        <div class="d-flex justify-content-center pt-2 mb-3 px-2">

                            <button class="btn w-75 syne-text auth-btn rounded-pill mb-3" type="submit"
                                [disabled]="loading" (click)="onSubmit()">

                                <span *ngIf="loading" class="spinner-border spinner-border-sm me-1">
                                </span>

                                {{ 'continue' | translate }}

                            </button>

                        </div>

                        <div class="d-flex align-items-center fs-16 mb-4">
                            <hr class="flex-grow-1">
                            <span class="px-2 fw-semibold syne-text ">{{ 'login2' | translate }}</span>
                            <hr class="flex-grow-1">
                        </div>

                        <div class="auth-social syne-text">
                            <button class="btn btn-white bdr-black mb-3 fs-16 rounded-pill custom-btn py-2"
                                (click)="triggerGoogleSignIn()">
                                <img src="assets/images/icons/google.png" alt="google" class="me-2" width="15"
                                    height="15">
                                Google
                            </button>

                            <button class="btn btn-white bdr-black rounded-pill custom-btn fs-16 py-2"
                                (click)="onLinkedIn()">
                                <img src="assets/images/icons/linkedin.png" alt="linkedin" class="me-2" width="15"
                                    height="15">
                                LinkedIn
                            </button>
                        </div>

                    </ng-container>

                    <ng-container *ngIf="showPasswordStep">

                        <!-- Password -->
                        <div class="mb-2">
                            <div *ngIf="inValidUser && errorMessage && submitted && !isSocialUser && !socialLinkedAccount"
                                class="error-text syne-text auth-sub fs-15 mb-2">
                                {{ errorMessage }}
                            </div>
                            <div *ngIf="inValidUser && submitted && socialLinkedAccount"
                                class="error-text text-start syne-text auth-sub fs-15 mb-2">
                                {{ 'social_login_password_info' | translate:{ provider: socialProvider } }}
                            </div>

                            <div class="position-relative">
                                <input [type]="showPassword ? 'text' : 'password'" id="" formControlName="password"
                                    class="form-control rounded-pill syne-text ps-4 pe-5 bdr-black py-2"
                                    placeholder="Password">
                                <i class="icon skf-eye position-absolute top-50 end-0 translate-middle-y me-3 cursor-pointer"
                                    onkeyup="" (click)="togglePassword()">
                                </i>
                            </div>

                            <div *ngIf="password.touched && password.invalid" class="error-text small mt-1 ps-2">
                                <div class="error-text syne-text fs-15" *ngIf="password.errors?.['required']">
                                    {{ 'login9' | translate }}
                                </div>
                            </div>
                        </div>

                        <div class="text-end mb-3">
                            <button type="button" class="btn fs-15 auth-link highlight text-decoration-none p-0"
                                (click)="openResetPopup()">
                                {{ 'login1' | translate }}
                            </button>
                        </div>

                        <div class="d-flex justify-content-center mb-4 pb-2">
                            <button class="btn w-75 syne-text auth-btn rounded-pill" type="submit" [disabled]="loading"
                                (click)="onSubmit()">
                                <span *ngIf="loading" class="spinner-border spinner-border-sm me-1">
                                </span>
                                {{ 'login7' | translate }}
                            </button>
                        </div>

                        <div class="d-flex align-items-center mb-2">
                            <hr class="flex-grow-1">
                            <span class="px-2 fw-semibold syne-text ">{{ 'login2' | translate }}</span>
                            <hr class="flex-grow-1">
                        </div>

                        <div class="d-flex text-center align-items-center mb-3">
                            <button type="button" class="btn btn-white bdr-black rounded-pill w-100 mt-2 py-2"
                                (click)="onSendLoginOtp()">
                                <i class="fa-regular fa-envelope me-2"></i>
                                {{ 'send_verification_code' | translate }}
                            </button>
                        </div>
                    </ng-container>
                </form>
            </div>
        </div>
    </div>
</div>

<button #resetBtn type="button" hidden data-bs-toggle="modal" data-bs-target="#forgotPasswordModal"></button>
<button #resetCloseBtn type="button" hidden data-bs-dismiss="modal" data-bs-target="#forgotPasswordModal"></button>

<div class="modal fade" id="forgotPasswordModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">

        <div class="modal-content border-0 shadow-lg rounded-4 p-4 position-relative ">

            <button type="button" class="btn-close position-absolute end-0 top-0 m-3" data-bs-dismiss="modal"
                aria-label="Close">
            </button>

            <div class="modal-title-big fs-32 syne-text mb-3 mt-4">
                {{ 'reset1' | translate }}<br>
                {{ 'reset9' | translate }}
            </div>

            <p class="text-center fs-15 mb-4">
                {{ 'reset2' | translate }}
            </p>

            <form [formGroup]="forgotPasswordForm" (ngSubmit)="onForgotPassword()"
                class="text-center justify-content-center">

                <div class="mb-4">
                    <div class="position-relative w-75 mx-auto">
                        <input type="email" id="" formControlName="email"
                            class="form-control rounded-pill bdr1 ps-4 pe-5 py-2" placeholder="E-mail">

                        <i
                            class="fa-regular fa-envelope position-absolute top-50 end-0 translate-middle-y me-3 text-muted"></i>
                    </div>
                    <div *ngIf="forgotPasswordEmail.touched && forgotPasswordEmail.invalid"
                        class="text-danger small mt-1 ps-2 ">
                        <div *ngIf="forgotPasswordEmail.errors?.['required']">{{'invalid_email' | translate}}</div>
                        <div *ngIf="forgotPasswordEmail.errors?.['email']">{{'login8' | translate}}</div>
                    </div>
                </div>

                <div class="d-flex justify-content-center mb-2">
                    <button class="btn w-50 syne-text auth-btn rounded-pill mb-3" type="submit" [disabled]="loading2">
                        {{ 'reset3' | translate }}
                    </button>
                </div>

            </form>
        </div>
    </div>
</div>

<button #emailSentBtn type="button" hidden data-bs-toggle="modal" data-bs-target="#emailSentModal"></button>

<div class="modal fade" id="emailSentModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">

        <div class="modal-content justify-content-center border-0 shadow-lg rounded-4 p-4 position-relative ">

            <button type="button" class="btn-close position-absolute end-0 top-0 m-3" data-bs-dismiss="modal"
                aria-label="Close">
            </button>

            <div *ngIf="message == 'mail-sent'">
                <div class="modal-title-big syne-text fs-32 mb-3 mt-4">
                    {{ 'reset4' | translate }}
                </div>

                <div class="text-center fs-16 mb-4">
                    {{ 'reset5' | translate }}
                    <span class="highlight">{{ email }}</span><br>
                    {{ 'reset6' | translate }}
                </div>

                <div class="text-center text-muted fs-16 mb-4">
                    {{'reset7' | translate}}<br>
                    {{'reset8' | translate}}
                </div>
            </div>

            <div *ngIf="['no-account', 'mail-not-sent'].includes(message)">
                <div class="text-center text-muted fs-16 mb-4">
                    {{'reset10' | translate}}
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="loginOtpModal" tabindex="-1" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content justify-content-center border-0 shadow-lg rounded-4 p-4 position-relative">
            <button type="button" class="btn-close position-absolute end-0 top-0 m-3" data-bs-dismiss="modal"></button>
            <div class="text-center mb-3 px-5 fs-30 syne-text fw-medium">
                {{ 'we_sent_code' | translate }}
            </div>
            <div class="text-center px-5 fs-16 mb-4">
                {{ ('enter_code_sent_to_email' | translate:{ email: this.username.value})}}
            </div>
            <form [formGroup]="otpForm" (ngSubmit)="verifyOtp()" class="text-center px-5">
                <div class="mb-3 px-5">
                    <input type="text" id="" maxlength="6" formControlName="otp"
                        class="form-control rounded-pill px-3 text-center bdr-black" placeholder="">
                    <div class="text-center mt-2 fs-16">
                        <div *ngIf="otpSubmitted &&  otpForm.get('otp')?.value?.trim()?.length > 0 && (otpForm.invalid || invalidOtp)"
                            class="error-text fs-16 mb-2">
                            {{ 'invalid_otp' | translate }}
                        </div>
                        <button type="button" class="btn border-0 p-0" [disabled]="!canResendOtp" (click)="resendOtp()">
                            <span class="error-text fs-16" *ngIf="canResendOtp">
                                {{ 'recieve_code' | translate }}
                            </span>
                            <span *ngIf="!canResendOtp" class="text-muted fs-16">
                                {{ ('resend_in_seconds' | translate:{ count: resendCooldown})}}
                            </span>
                        </button>
                    </div>
                </div>
                <button class="btn w-50 p-2 auth-btn fs-16 rounded-pill" type="submit"
                    [disabled]="verifyingOtp || !otpForm.value.otp">
                    {{('login7' | translate )}}
                </button>
            </form>
        </div>
    </div>
</div>


<div class="modal fade" id="companyAccountRestrictedModal" tabindex="-1" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered">
        <div
            class="modal-content accountRestrictionModal justify-content-center border-0 shadow-lg rounded-4 p-4 position-relative">
            <button type="button" class="btn-close position-absolute end-0 top-0 m-3" data-bs-dismiss="modal"></button>
            <div class="px-4 fs-16 fs-30 syne-text fw-medium">
                {{('company_account_not_allowed' | translate )}}
            </div>
        </div>
    </div>
</div>